import axios from 'axios';

import { SCENARIO_EMPLOYMENT_SETTINGS } from '../endpoints';

export type PostEmploymentSettingsPayload = {
  excluded: boolean;
  employmentId: number;
};

type SaveEmploymentSettingsOptions = {
  scenarioId: number;
  payload: PostEmploymentSettingsPayload;
};

export const saveEmploymentSettings = ({
  payload,
  scenarioId
}: SaveEmploymentSettingsOptions) =>
  axios.post(SCENARIO_EMPLOYMENT_SETTINGS, payload, {
    pathParams: { scenarioId }
  });
